// All categories related apis
import { API_URL } from "./api";
import instance from "./api";
import { encryptData } from "../helpers/encryptDecrypt";

// Get api for fetching all the categories for the active organization
export const fetchCategoriesByOrganization = async (organizationId, keyword) => {
  const oId = encryptData(organizationId);
  return await instance.get(`${API_URL}/organizations/${oId}/categories?keyword=${keyword}`);
};

// Post api for creating new category and link it with the active organization
export const addCategory = async (category) => {
  return await instance.post(`${API_URL}/categories`, category);
};

// Put api for updating the existing category's details
export const updateCategory = async (id, category) => {
  const cId = encryptData(id);
  return await instance.put(`${API_URL}/categories/${cId}`, category);
};

// Delete api for deleting the existing category
export const deleteCategory = async (id) => {
  const cId = encryptData(id);
  return await instance.delete(`${API_URL}/categories/${cId}`);
};
